(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
function initializeBrandFilters() {
  document.querySelectorAll('[data-brand-filter]').forEach(root => {
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const select=root.querySelector('[data-brand-select]');
    const form=root.querySelector('[data-brand-form]');
    const selectedBrand=new URLSearchParams(window.location.search).get('q');
    if(window.location.pathname.endsWith('/collections/vendors') && selectedBrand && Array.from(select.options).some(option=>option.value===selectedBrand))select.value=selectedBrand;
    select.addEventListener('change',()=>{if(select.value)form.requestSubmit();});
  });
}
initializeBrandFilters();
document.addEventListener('shopify:section:load',initializeBrandFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
function initializeBrandFilters() {
  document.querySelectorAll('[data-brand-filter]').forEach(root => {
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const select=root.querySelector('[data-brand-select]');
    const form=root.querySelector('[data-brand-form]');
    const selectedBrand=new URLSearchParams(window.location.search).get('q');
    if(window.location.pathname.endsWith('/collections/vendors') && selectedBrand && Array.from(select.options).some(option=>option.value===selectedBrand))select.value=selectedBrand;
    select.addEventListener('change',()=>{if(select.value)form.requestSubmit();});
  });
}
initializeBrandFilters();
document.addEventListener('shopify:section:load',initializeBrandFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
